export default "__VITE_ASSET__CFE$$WGK__"